import axios from "axios";
import { Response } from "../../../shared/models/Response";

export class RuleService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/rules`;
  }

  async checkBillingRulesByServiceTemplate(
    serviceTemplateId: string
  ): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/check-billing-by-service-template/${serviceTemplateId}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
